import queryString from 'query-string';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient from 'api/axiosClient';
import { setGlobalLoading } from 'app/commonRedux/appSlice';
import { notificationToast } from 'components/notificationToast';
import { actions } from './performanceSlice';
import { Notification } from 'constants/notification';

export const getManagerView = createAsyncThunk(
  '/performance/manager-view/underline-employees',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/performance/manager-view/underline-employees?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const createReviewCycle = createAsyncThunk(
  '/performance/review',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const { body, callBack } = params;

      const response = await axiosClient.post(`/performance/review`, body);
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const getPerformanceTemplates = createAsyncThunk(
  '/performance/configuration/templates',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(`/performance/configuration/templates?status=true`);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getPerformanceTemplate = createAsyncThunk(
  'performance/configuration/templates/detail/:id',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `performance/configuration/templates/detail/${params?.id}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getReviewCycle = createAsyncThunk(
  '/performance/review',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/performance/review?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getAssessmentDetail = createAsyncThunk(
  '/performance/review/assessment/detail',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/performance/review/assessment/detail?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getPendingReviewPerformance = createAsyncThunk(
  '/performance/pending-review',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/performance/pending-review?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getCycleList = createAsyncThunk(
  '/performance/review/cycles',
  async (_: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(`/performance/review/cycles`);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const startReviewCycle = createAsyncThunk(
  '/performance/review/start-review/',
  async (params: any, thunkApi: any) => {
    try {
      const { id, callBack } = params;
      const response = await axiosClient.post(`/performance/review/start-review/${id}`);
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getDetailCycle = createAsyncThunk(
  '/performance/review/detail/',
  async (params: any, thunkApi: any) => {
    try {
      const { id } = params;
      const response = await axiosClient.get(`/performance/review/detail/${id}`);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getListAssessmentEmployee = createAsyncThunk(
  '/performance/review/assessment-all',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/performance/review/assessment?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const updateAssessmentForm = createAsyncThunk(
  '/performance/review/assessment/:assessmentId',
  async (params: any, thunkApi: any) => {
    try {
      const { id, body, callBack } = params;
      const response = await axiosClient.put(`/performance/review/assessment/${id}`, body);
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getHRPerformanceView = createAsyncThunk(
  '/performance/review/assessment/list-by-cycle',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/performance/review/assessment/list-by-cycle?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const deleteReviewCycle = createAsyncThunk(
  '/performance/review/delete',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const { id, callBack } = params;
      const response = await axiosClient.delete(`/performance/review/${id}`);
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const updateReviewCycle = createAsyncThunk(
  '/performance/review/:id',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const { body, callBack, id } = params;

      const response = await axiosClient.put(`/performance/review/${id}`, body);
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const updateGoalMainResponsibilities = createAsyncThunk(
  '/performance/review/step/:id',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const { goals, callBack, id } = params;

      const response = await axiosClient.put(`/performance/review/step/${id}`, { goals });
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const cancelReviewCycle = createAsyncThunk(
  '/performance/review/status/:id',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const { id, callBack } = params;
      const response = await axiosClient.put(`/performance/review/status/${id}`);
      callBack && callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const exportPerformanceReviewCycle = createAsyncThunk(
  'performance/review/review-cycle/export',
  async (params: any, thunkApi: any) => {
    try {
      const res: any = await axiosClient.post(
        `performance/review/review-cycle/export`,
        { ids: params },
        {
          responseType: 'blob',
        },
      );
      const url = window.URL.createObjectURL(new Blob([res]));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Performance_Review_Cycle.xlsx`);
      document.body.appendChild(link);
      link.click();
      return res;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const exportPerformanceReviewReport = createAsyncThunk(
  'performance/review/report',
  async (params: { fromDate: string; toDate: string }, thunkApi: any) => {
    try {
      const res: any = await axiosClient.post(`performance/review/report`, params, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res]));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `Performance_Review_Report_${params.fromDate}_${params.toDate}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      return res;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const duplicateReviewCycle = createAsyncThunk(
  'performance/duplicateTemplate',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const { id, callBack } = params;

      // Call duplicate API
      const response = await axiosClient.post<{ id: string }>(
        `/performance/configuration/templates/duplicate/${id}`,
      );

      if (response?.data?.id) {
        try {
          // Fetch detailed information of the duplicated template
          const detailResponse = await axiosClient.get(
            `/performance/configuration/templates/detail/${response.data.id}`,
          );

          if (detailResponse?.data) {
            // Update the store with the new template details
            thunkApi.dispatch({
              type: getDetailCycle.fulfilled.type,
              payload: { data: detailResponse.data },
            });

            // Execute callback with the new template ID
            callBack?.(detailResponse.data.id);
          }

          notificationToast(Notification.Type.Success, 'Template duplicated successfully.', 3);
        } catch (detailError) {
          console.error('Failed to fetch template details:', detailError);
          // Still show success since duplication was successful
          notificationToast(
            Notification.Type.Success,
            'Template duplicated, but there was an issue loading the details.',
            3,
          );
        }
      }

      return response;
    } catch (error) {
      console.error('Duplicate template failed:', error);
      notificationToast(
        Notification.Type.Error,
        'Failed to duplicate template. Please try again.',
        3,
      );
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);
